module.exports = __webpack_public_path__ + "img/shutterstock_380872402.9006a713.jpg";